import i18n from '@/lib/i18n'

export default class StripePaymentMethodTypes {
  static get CustomerBalance() {
    return 'customer_balance'
  }

  static get Card() {
    return 'card'
  }

  // CollectionMethodがsend_invoiceの場合は請求書払い
  static get SendInvoice() {
    return 'send_invoice'
  }

  static getStripePaymentMethodTypes() {
    return [
      {
        name: i18n.tt('customBankTransfer'),
        value: StripePaymentMethodTypes.CustomerBalance,
      },
      {
        name: i18n.tt('customCreditCard'),
        value: StripePaymentMethodTypes.Card,
      },
    ]
  }

  static getStripeCardPaymentMethodTypeOnly() {
    return [
      {
        name: i18n.tt('customCreditCard'),
        value: StripePaymentMethodTypes.Card,
      },
    ]
  }

  static isCard(paymentMethodType) {
    return StripePaymentMethodTypes.Card === paymentMethodType
  }

  static isCustomerBalance(paymentMethodType) {
    return StripePaymentMethodTypes.CustomerBalance === paymentMethodType
  }

  // CollectionMethodがsend_invoiceの場合は請求書払い。カード払いはcharge_automatically
  static isSendInvoice(collectionMethod) {
    return StripePaymentMethodTypes.SendInvoice === collectionMethod
  }

  static getItemByStripePaymentMethodType(value) {
    const items = this.getStripePaymentMethodTypes()
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      if (item.value === value) {
        return item
      }
    }
    return null
  }
}
